import { createContext, useMemo, useState } from "react";

export const DocumentControlContext = createContext({});

const DocumentControlContextProvider = ({ children }) => {
  const [undoAction, setUndoAction] = useState(() => () => {
    alert("undoAction");
  });
  const [redoAction, setRedoAction] = useState(() => () => {
    alert("redoAction");
  });
  const [saveAction, setSaveAction] = useState(() => () => {
    alert("saveAction");
  });
  const [cancelAction, setCancelAction] = useState(() => () => {
    alert("cancelAction");
  });
  const [tableViewAction, setTableViewAction] = useState(() => () => {
    alert("tableViewAction");
  });

  const actions = useMemo(() => ({ undoAction, redoAction, saveAction, cancelAction,tableViewAction }), []);

  const setActions = useMemo(
    () => ({
      undoAction: setUndoAction,
      redoAction: setRedoAction,
      saveAction: setSaveAction,
      cancelAction: setCancelAction,
      tableViewAction:setTableViewAction
    }),
    []
  );

  return <DocumentControlContext.Provider value={[actions, setActions]}>{children}</DocumentControlContext.Provider>;
};

export default DocumentControlContextProvider;
